import AsnDetailStore from "../../../stores/AsnDetailStore";
import DomainStore from "../../../stores/CmrDomainStore";
import ServiceStore from "../../../stores/CmrServiceStore";
import ProductItemStore from "../../../stores/ProductItemStore";
import {isTruthy} from "../../../utilities/general";
import _ from "underscore";

const productItemKeyToManditoryDomainStrMapping = {
  prdBarcodeRequired: {
    checkIfNeedsManditoryService: (productItem)=>{
      return ProductItemStore.needsBarcode(productItem);
    },
    mandatoryStr: "barcode_item_level_mandatory_services"
  },
  // prdFragile: {
  //   mandatoryStr: "fragile_item_level_mandatory_services"
  // }
};


export default function MandatoryServiceProcessor(asnDetailIds){
  const self = this;
  const domainsByMandatoryStr = DomainStore.groupByCdmDomain();

  self.forceAddMandatoryServices = function(){
    _(asnDetailIds).map(handleAsnDetailMandatoriesFunc("_mandatoryMappingFunc"));
  };

  self.forceRemoveUnneededMandatoryServices = function(){
    _(asnDetailIds).map(handleAsnDetailMandatoriesFunc("_removalMandatoryMappingFunc"));
  };





  function handleAsnDetailMandatoriesFunc(funcName){
    return (asnDetailId)=>{
      handleAsnDetailMandatories(asnDetailId, funcName);
    };
  }

  function handleAsnDetailMandatories(asnDetailId, mappingFunc){
    const asnDetail = AsnDetailStore.getData()[asnDetailId];
    const productItem = ProductItemStore.getDataViaAsnDetail(asnDetail)[0];
    if(productItem){
      _(productItemKeyToManditoryDomainStrMapping).mapObject(self[mappingFunc](asnDetail, productItem));
    }
  }


  self._removalMandatoryMappingFunc = function(asnDetail, productItem){
    return ({mandatoryStr, checkIfNeedsManditoryService}, productItemKey)=>{
      const requiresService = doesRequireService({checkIfNeedsManditoryService, productItem, productItemKey});

      // if the product does not require a mandatory service,
      // make sure it doesn't have that mandatory service by removing it
      // if it exists
      if(!requiresService){
        let domain = domainsByMandatoryStr[mandatoryStr];
        domain = domain && domain[0];
        if(domain){
          // find service linking this domain to the asnDetail
          let service = ServiceStore.findWhere({csv_entity_id: asnDetail.id, csv_entity_type: "asn_detail", cdm_id: domain.id});
          if(service){
            removeService(service);
          }
        }
      }
    }
  }



  function removeService(service){
    ServiceStore.removeServicesByIds([service.id]);
  }




  self._mandatoryMappingFunc = function(asnDetail, productItem){
    return ({mandatoryStr, checkIfNeedsManditoryService}, productItemKey)=>{
      const requiresService = doesRequireService({checkIfNeedsManditoryService, productItem, productItemKey});
      // check if a service exists connecting asnDetail to the given manditory domain
      if(requiresService){
        let domain = domainsByMandatoryStr[mandatoryStr];
        // it's was an object organized by str point to array, and we only care about the first of each
        domain = domain && domain[0];
        if(domain){
          const service = ServiceStore.findWhere({csv_entity_id: asnDetail.id, csv_entity_type: "asn_detail", cdm_id: domain.id});
          if(!service){
            createMandatoryServiceFor(asnDetail, domain);
          }
        }
      }
    }
  }

  function createMandatoryServiceFor(asnDetail, domain){
    ServiceStore.createOrUpdateServicesForAsnDetailIds([asnDetail.id], {
      cdm_id: domain.id
    });
  }
}

function doesRequireService({checkIfNeedsManditoryService, productItem, productItemKey}){
  let requiresService;
  // if the config object at top of file has a productItemStoreFuncName,
  // use this as the discerning factor of whether or not the given 
  // product item needs a service
  if(checkIfNeedsManditoryService){
    requiresService = checkIfNeedsManditoryService(productItem);
  }
  else{
    // otherwise, just use the productItemKey itself to determine
    // if the given product needs a service
    requiresService = isTruthy(productItem[productItemKey]);
  }

  return requiresService;
}



// WEBPACK FOOTER //
// ./src/pages/asns/businessLogic/MandatoryServiceProcessor.js